(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-testimonial-direction]');
    if (!control) return;

    const section = control.closest('.shopify-section--testimonials');
    const carousel = section ? section.querySelector('testimonial-carousel') : null;
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.testimonial-item'));
    if (slides.length < 2) return;

    const carouselLeft = carousel.getBoundingClientRect().left;
    let currentIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - carouselLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = index;
      }
    });

    const direction = control.dataset.testimonialDirection === 'previous' ? -1 : 1;
    const nextIndex = (currentIndex + direction + slides.length) % slides.length;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    slides[nextIndex].scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
